import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useMenuConsultaProduto } from "app/components/menu-consulta-produtos/useMenuConsultaProduto";
import { useMenuSubConsulta } from "app/components/menu-sub-consulta-produto/useMenuSubConsultaProduto";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { memo, useEffect, useRef, useState } from "react";
import { EntitesDadosEstoque } from "../../Estoque";
import { DadosPedidoCliente, PedidosCliente } from "./PedidosCliente";


declare var window: any;

export type PedidoClienteConatinerProps = {
  estoqueSelecionado: EntitesDadosEstoque;
  item: IItemOrcamento;
  //dadosEstoque: PagedMessageResponse<EntitesDadosEstoque>;
  onRemover: () => void;
  onVoltar: () => void;
  passos: Dict<string, () => void>;
  foraOrcamento: boolean
};

export type PesquisaSubConsultas = {
  CodigoFilial: string;
  CodigoProduto: string;
  NumeroPagina: number;
  TamanhoPagina: number;
};

export const PedidoClienteContainer = memo((props: PedidoClienteConatinerProps) => {
  const isMounted = useRef<boolean>(true);
  const [dadosPesquisaPedidosCliente, setDadosPesquisaPedidosCliente] =useState<PagedMessageResponse<DadosPedidoCliente>>();

  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))


  const onObterPedidosClientePaginado = async (numeroPagina?: number) => {
    try {
      const resposta = await microuniversoApi.Produto.pedidoCliente({
        CodigoFilial: props.estoqueSelecionado.Filial,
        CodigoProduto: props.estoqueSelecionado.Codigo,
        NumeroPagina: numeroPagina,
        TamanhoPagina: 0,
      });
      if (!isMounted.current) return;
      setDadosPesquisaPedidosCliente(resposta);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onVoltar = () => {
    props.onRemover()
    props.onVoltar()
}

const onPassoSelecionado = (passo: string) => {
    props.onRemover()
    passosInterno.current.get(passo)()
}

  const onObterPedidosCliente = async () => {
    try {
      const resposta = await microuniversoApi.Produto.pedidoCliente({
        CodigoFilial: props.estoqueSelecionado.Filial,
        CodigoProduto: props.estoqueSelecionado.Codigo,
        NumeroPagina: 0,
        TamanhoPagina: 0,
      });
      if (!isMounted.current) return;
      setDadosPesquisaPedidosCliente(resposta);
    } catch (e) {
      tratamentoErroPadrao(e);
      onVoltar();
    } finally {
      globalMU.unblockUI();
    }
  };

  useMenuSubConsulta(props)
  useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.remove("Estoque do Produto").map)), props.onVoltar, props.item, props.foraOrcamento)

  useEffect(() => () => { isMounted.current = false }, [])

  useEffect(() => {
    passosInterno.current.set("Estoque do Produto", () => props.onVoltar())
    passosInterno.current.set("Pedidos Cliente", () => { })
    onObterPedidosCliente();
  }, []);

  return (
    <>
      <Breadcrumb2Container
        passos={passosInterno.current.keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        onBotaoVoltarClicado={onVoltar}
        onPassoSelecionado={onPassoSelecionado}
        id="PedidoClienteBreadcrumb"
      />
      <br />

      <PedidosCliente
        dadosPesquisaPedidosCliente={dadosPesquisaPedidosCliente}
        onPesquisarPaginado={onObterPedidosClientePaginado}
      />
    </>
  );
});
